import { apiClient, API_PRX } from '@indipia/shared';
import type { ApiResponse } from '@indipia/shared-types';
import type {
  CustomerSearchResult,
  PartnerSearchResult,
  VendorSearchResult,
} from './types';

// X-Comp-Id는 FlowGate가 JWT에서 추출해 주입한다 (C-05 §3.5). FE에서 직접 세팅 금지.

export async function searchCustomers(keyword: string): Promise<CustomerSearchResult[]> {
  const res = await apiClient.get<ApiResponse<CustomerSearchResult[]>>(
    `${API_PRX.CUSTOMER}/customers`,
    { params: { keyword } },
  );
  return Array.isArray(res.data.data) ? res.data.data : [];
}

/** 시공파트너(작업요청 후보) 검색 — 통합 원장에서 role=CONSTRUCTION(시공·둘다)만 */
export async function searchPartners(keyword: string): Promise<PartnerSearchResult[]> {
  const res = await apiClient.get<ApiResponse<PartnerSearchResult[]>>(
    `${API_PRX.MEMBER}/partners`,
    { params: { keyword, role: 'CONSTRUCTION' } },
  );
  return Array.isArray(res.data.data) ? res.data.data : [];
}

/** 자재파트너(구 거래처) 검색 — 통합 원장에서 role=MATERIAL(자재·둘다)만, 응답을 거래처 형태로 매핑 */
export async function searchVendors(keyword: string): Promise<VendorSearchResult[]> {
  const res = await apiClient.get<ApiResponse<Array<{
    partnerId: number;
    partnerName: string;
    partnerBizName: string | null;
    mobile: string;
    contactName: string | null;
  }>>>(
    `${API_PRX.MEMBER}/partners`,
    { params: { keyword, role: 'MATERIAL' } },
  );
  const rows = Array.isArray(res.data.data) ? res.data.data : [];
  return rows.map((p) => ({
    vendorId: p.partnerId,
    vendorName: p.partnerBizName ?? p.partnerName,
    vendorPhone: p.mobile,
    contactName: p.contactName ?? undefined,
  }));
}

export async function createCustomer(customerName: string, mobile: string): Promise<void> {
  await apiClient.post(`${API_PRX.CUSTOMER}/customers`, { customerName, customerMobile: mobile });
}

export async function createPartner(
  partnerName: string,
  phone: string,
  specialtyTypes?: string,
): Promise<void> {
  await apiClient.post(`${API_PRX.MEMBER}/partners`, {
    partnerName,
    mobile: phone,
    partnerRole: 'CONSTRUCTION',
    specialtyTypes: specialtyTypes || undefined,
    partnerBizYn: 'N',
  });
}

export async function createVendor(
  vendorName: string,
  contactName: string,
  phone: string,
  dealItem?: string,
): Promise<void> {
  // 자재거래처→시공파트너 원장 통합: 자재파트너는 /member/partners(partnerRole=MATERIAL)로 등록된다.
  await apiClient.post(`${API_PRX.MEMBER}/partners`, {
    partnerName: vendorName,
    mobile: phone,
    partnerRole: 'MATERIAL',
    contactName,
    dealItem: dealItem || undefined,
    partnerBizYn: 'N',
  });
}
